import { Button } from '@mui/material'

export default function ButtonLink(props) {
  return (
    <Button
      href={props.link}
      target='_blank'
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      size='large'
      color={props.color}
      sx={{
        justifyContent: 'flex-start',
        height: 46,
        minWidth: 225,
        maxWidth: '100%',
        boxShadow: 1,
        borderRadius: 1,
        px: 2,
        fontWeight: props.bold ? 'bold' : 'normal',
        transition: '0.2s all ease-in-out',
        '&:hover': { boxShadow: 3 },
        '& .MuiButton-endIcon': { ml: 'auto' },
      }}>
      <span style={{ marginRight: '12px' }}>{props.label}</span>
    </Button>
  )
}
